export const TEST_RIDE_SUMMARY = {
  DASHBOARD_ID: "f6d62853-ec86-47d7-a058-850dd6167997",
  DASHBOARD_NAME: "new-test-drive-summary",
  BASE_VARIABLES: [
    "orgId",
    "vehicle_id",
    "testid",
    "interval",
    "from",
    "to",
    "rear_wheel_diameter",
  ],
  DRIVE_MODE_VARIABLES: [
    "drive_mode1",
    "drive_mode2",
    "drive_mode3",
    "drive_mode4",
    "drive_mode5",
  ],
  DCCL_VARIABLES: [
    "orgId",
    "vehicle_id",
    "testid",
    "interval",
    "from",
    "to",
    "rear_wheel_diameter",
    "dccl_range",
  ],
  ACCL_VARIABLES: [
    "orgId",
    "vehicle_id",
    "testid",
    "interval",
    "from",
    "to",
    "rear_wheel_diameter",
    "accl_range",
  ],
  PANEL_ID: {
    geo: {
      loc: 11,
      locSpeed: 104,
      locAltitude: 105,
      locDriveMode: 103,
      locAiTemp: 107,
      locMcs: 108,
      locMotor: 109,
      locBattery: 110,
      locSoc: 112,
    },
    speed: {
      timeSeries: 12,
      histogram: 13,
      boxPlot: 14,
    },
    MCS: {
      timeSeries: 40,
      histogram: 41,
      boxPlot: 42,
    },
    motor: {
      timeSeries: 37,
      histogram: 38,
      boxPlot: 39,
    },
    battery: {
      timeSeries: 28,
      histogram: 29,
      boxPlot: 30,
    },
    batteryVoltage: {
      timeSeries: 31,
      histogram: 32,
      boxPlot: 33,
    },
    batteryCurrent: {
      timeSeries: 34,
      histogram: 35,
      boxPlot: 36,
    },
    batterySOC: {
      timeSeries: 49,
      histogram: 50,
      boxPlot: 51,
    },
    batterySOH: {
      timeSeries: 52,
      histogram: 53,
      boxPlot: 54,
    },
    batteryMinTemp: {
      timeSeries: 58,
      histogram: 61,
      boxPlot: 60,
    },
    batteryMaxTemp: {
      timeSeries: 55,
      histogram: 56,
      boxPlot: 57,
    },
    batteryMosfetTemp: {
      timeSeries: 113,
      histogram: 114,
      boxPlot: 115,
    },
    brakeDuration: {
      timeSeries: 8,
      histogram: 9,
      boxPlot: 19,
    },
    brakeDistance: {
      timeSeries: 15,
      histogram: 16,
      boxPlot: 20,
    },
    brakeIntensity: {
      timeSeries: 94,
      histogram: 95,
      boxPlot: 96,
    },
    turns: {
      timeSeries: 99,
      histogram: 100,
      boxPlot: 101,
    },
    stopsDuration: {
      timeSeries: 71,
      histogram: 72,
      boxPlot: 73,
    },
    energyMetrics: {
      timeSeries: 91,
      histogram: 92,
      boxPlot: 93,
    },
    AccelerationDistance: {
      timeSeries: 75,
      histogram: 79,
      boxPlot: 81,
    },
    AccelerationDuration: {
      timeSeries: 78,
      histogram: 80,
      boxPlot: 82,
    },
    DecelerationDistance: {
      timeSeries: 83,
      histogram: 85,
      boxPlot: 87,
    },
    DecelerationDuration: {
      timeSeries: 84,
      histogram: 86,
      boxPlot: 88,
    },
    cellVoltages: 66,
    batterySensor: {
      timeSeries: 67,
      histogram: 68,
      boxPlot: 69,
    },
  },
};

export const TEST_RIDE_CUMULATIVE = {
  DASHBOARD_ID: "bf83e667-6e25-4c6a-950c-e099f47757bf",
  DASHBOARD_NAME: "test-drive-cumulative-left",
  BASE_VARIABLES: ["orgId", "interval", "from", "to", "trip_ids"],
  PANEL_ID: {
    speed: {
      histogram: 1,
      boxPlot: 4,
    },
    batteryVoltage: {
      histogram: 20,
      boxPlot: 23,
    },
    batteryCurrent: {
      histogram: 18,
      boxPlot: 22,
    },
    batterySOC: {
      histogram: 25,
      boxPlot: 26,
    },
    batterySOH: {
      histogram: 28,
      boxPlot: 29,
    },
    batteryMinTemp: {
      histogram: 34,
      boxPlot: 35,
    },
    batteryMaxTemp: {
      histogram: 31,
      boxPlot: 32,
    },
    brakeDuration: {
      histogram: 7,
      boxPlot: 8,
    },
    brakeDistance: {
      histogram: 11,
      boxPlot: 12,
    },
  },
};

export const FLEET_STATUS = {
  DASHBOARD_ID: "f06cec50-219b-40d7-8be5-1c68166ddaef",
  DASHBOARD_NAME: "fleet-status",
  // CITY_VARIABLES: ["orgId", "city", "fleet_id", "refresh"],
  FLEET_VARIABLES: ["orgId", "fleet_id", "refresh"],
  PANEL_ID: {
    vehiclesMap: 6,
    vehicleRunningNo: 2,
    vehiclesStoppedNo: 3,
    vehiclesIdlingNo: 4,
    vehiclesOfflineNo: 5,
  },
};

export const BATTERY_STATUS = {
  VEHICLE: {
    DASHBOARD_ID: "cf7a11f5-3451-4ced-91c5-4659b72e1634",
    DASHBOARD_NAME: "new-battery-status-for-a-vehicle",
    BASE_VARIABLES: ["orgId", "vehicle_id", "bucket_interval", "from", "to"],
    BATTERY_VARIABLES: [
      "orgId",
      "vehicle_id",
      "bucket_interval",
      "from",
      "to",
      "batteryfield",
    ],
    PANEL_ID: {
      genericData: {
        timeSeries: 2,
        histogram: 3,
        boxPlot: 6,
      },
      cellData: {
        timeSeries: 9,
        histogram: 12,
        boxPlot: 16,
      },
      sensorData: {
        timeSeries: 11,
        histogram: 15,
        boxPlot: 14,
      },
    },
  },
  FLEET: {
    DASHBOARD_ID: "cf7a11f5-3451-4ced-91c5-4659b72e1633",
    DASHBOARD_NAME: "battery-status-for-a-fleet",
    BASE_VARIABLES: [
      "orgId",
      "batteryfield",
      "bucket_interval",
      "from",
      "to",
      "imei",
      "fleet_id",
      "model_id",
    ],
    PANEL_ID: {
      genericData: {
        avgHistogram: 2,
        medianHistogram: 8,
      },
    },
  },
};

export const EOL_TESTS = {
  // CONNECTIVITY: {
  //   DASHBOARD_ID: "bbeb33a9-6b02-46cd-b9e2-be84fc52a2dg",
  //   DASHBOARD_NAME: "eol-heart-beat-testing",
  //   BASE_VARIABLES: ["orgId", "imei", "from", "to"],
  //   RUNNING_VARIABLES: ["orgId", "imei", "refresh"],
  //   PANEL_ID: {
  //     current: 6,
  //     voltage: 5,
  //   },
  // },
  DYNO: {
    DASHBOARD_ID: "c4d4b681-6104-4877-aeee-b366cebc4066",
    DASHBOARD_NAME: "new-eol-dyno-testing",
    BASE_VARIABLES: ["orgId", "vehicle_id", "from", "to", "rear_wheel_diameter"],
    RUNNING_VARIABLES: ["orgId", "vehicle_id", "rear_wheel_diameter", "refresh"],
    MODE_VARIABLES: [
      "orgId",
      "vehicle_id",
      "from",
      "to",
      "drive_mode",
      "rear_wheel_diameter",
    ],
    PANEL_ID: {
      current: 4,
      speed: 15,
      history: {
        mode: {
          timeSeries: 2,
          histogram: 16,
          boxPlot: 17,
        },
        reverse: {
          timeSeries: 3,
          histogram: 22,
          boxPlot: 23,
        },
      },
    },
  },
};

export const EOL_STATISTICS = {
  CONNECTIVITY: {
    DASHBOARD_ID: "e24b93f7-cc13-40f8-9a83-0106979f23e3",
    DASHBOARD_NAME: "eol-heart-beat-summary",
    BASE_VARIABLES: ["orgId"],
    PANEL_ID: {
      panel1: 7,
      panel2: 1,
    },
  },
  DYNO: {
    DASHBOARD_ID: "dae3ec3c-2167-4a28-a105-c105579d80c6",
    DASHBOARD_NAME: "eol-dyno-summary",
    BASE_VARIABLES: ["orgId"],
    PANEL_ID: {
      panel1: 1,
      panel2: 2,
      speed: 4,
      current: 15,
    },
  },
};

export const VEHICLE_STATUS = {
  DASHBOARD_ID: "cf7a11f5-3451-4ced-91c5-4659b72e1657",
  DASHBOARD_NAME: "new-vehicle-status-page-aggregates",
  BASE_VARIABLES: ["orgId", "vehicle_id", "bucket_interval", "from", "to"],
  RUNNING_VARIABLES: ["orgId", "vehicle_id", "bucket_interval", "from", "refresh"],
  SPEED_VARIABLES: ["motorfield", "rear_wheel_diameter"],
  TELEMETRY_VARIABLES: ["telemetryfield"],
  MOTOR_VARIABLES: ["motorfield"],
  BATTERY_VARIABLES: ["batteryfield"],
  PANEL_ID: {
    route: 19,
    lastLocation: 7,
    locationSpeed: 20,
    locationAltitude: 21,
    accel_x_axis: {
      timeSeries: 2,
      histogram: 3,
      boxPlot: 6,
    },
    accel_y_axis: {
      timeSeries: 2,
      histogram: 3,
      boxPlot: 6,
    },
    accel_z_axis: {
      timeSeries: 2,
      histogram: 3,
      boxPlot: 6,
    },
    ai_lean_angle: {
      timeSeries: 2,
      histogram: 3,
      boxPlot: 6,
    },
    ai_system_voltage: {
      timeSeries: 2,
      histogram: 3,
      boxPlot: 6,
    },
    ai_temperature: {
      timeSeries: 2,
      histogram: 3,
      boxPlot: 6,
    },
    ai_voltage_input: {
      timeSeries: 2,
      histogram: 3,
      boxPlot: 6,
    },
    motor_dc_current: {
      timeSeries: 2,
      histogram: 3,
      boxPlot: 6,
    },
    motor_dc_voltage: {
      timeSeries: 25,
      histogram: 26,
      boxPlot: 27,
    },
    motor_mcs_temperature: {
      timeSeries: 25,
      histogram: 26,
      boxPlot: 27,
    },
    motor_temperature: {
      timeSeries: 25,
      histogram: 26,
      boxPlot: 27,
    },
    motor_throttle: {
      timeSeries: 25,
      histogram: 26,
      boxPlot: 27,
    },
    motor_speed: {
      timeSeries: 22,
      histogram: 23,
      boxPlot: 24,
    },
    battery_volt: {
      timeSeries: 15,
      histogram: 16,
      boxPlot: 17,
    },
    current: {
      timeSeries: 15,
      histogram: 16,
      boxPlot: 17,
    },
    soc: {
      timeSeries: 15,
      histogram: 16,
      boxPlot: 17,
    },
    soh: {
      timeSeries: 15,
      histogram: 16,
      boxPlot: 17,
    },
    temperature_max: {
      timeSeries: 15,
      histogram: 16,
      boxPlot: 17,
    },
    temperature_min: {
      timeSeries: 15,
      histogram: 16,
      boxPlot: 17,
    },
    mosfet_temperature: {
      timeSeries: 15,
      histogram: 16,
      boxPlot: 17,
    },
    sensor_temperature: {
      timeSeries: 7,
      histogram: 8,
      boxPlot: 9,
    },
    cell_voltage: {
      timeSeries: 10,
      histogram: 11,
      boxPlot: 12,
    },
  },
};

export const HOME = {
  DASHBOARD_ID: "f06cec50-219b-40d7-8be5-1c68166aaddeg",
  DASHBOARD_NAME: "generic-landing-page",
  BASE_VARIABLES: ["orgId", "refresh"],
  PANEL_ID: {
    Map: 15,
    Running: 11,
    Stopped: 12,
    Idling: 13,
    Offline: 14,
    RunningImieList: 18,
    StoppedImieList: 19,
    IdlingImieList: 20,
    OfflineImieList: 21,
    topRunning: 16,
    leastRunning: 17,
  },
};

// export const PRODUCT_HEALTH = {
//   DASHBOARD_ID: "cf7a11f5-3451-4ced-91c5-4659b72e163d",
//   DASHBOARD_NAME: "executive-landing-page-details",
//   BATTERY_VARIABLES: ["orgId", "imei", "bucket_interval", "from", "to"],
//   MOTOR_VARIABLES: [
//     "orgId",
//     "imei",
//     "motorfield",
//     "bucket_interval",
//     "from",
//     "to",
//   ],
//   PANEL_ID: {
//     sensor: {
//       voltage: {
//         timeSeries: 10,
//         histogram: 11,
//         boxPlot: 12,
//       },
//       temperature: {
//         timeSeries: 7,
//         histogram: 8,
//         boxPlot: 9,
//       },
//     },
//     motor: {
//       timeSeries: 2,
//       histogram: 3,
//       boxPlot: 6,
//     },
//   },
// };
